export default {
  display: 'block', 
  width: '300px', 
  margin: '10px'
}